import Header from './Header';
import Footer from './Footer';
import './styles/App.css';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Galerie from './Galerie';
import Acceuil from './Acceuil';
import Contact from './Contact';
import Materiels from './Materiels';
import Fournisseurs from './Fournisseurs';
import Clients from './Clients';

function App() {
  return (
    <Router>
      <div id="App" className="App">
        <Header />
        <main className="App-Body"> 
          <Routes>
            <Route path="/" element={<Acceuil />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/materiels" element={<Materiels />} />
            <Route path="/fournisseurs" element={<Fournisseurs />} />
            <Route path="/clients" element={<Clients />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
